document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('[data-cart-page]');
  if (!container) return;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateHeaderCartCount(count) {
    var countEls = document.querySelectorAll('.custom-header__cart-count');
    if (count > 0) {
      if (countEls.length > 0) {
        countEls.forEach(function (el) { el.textContent = count; });
      }
    } else {
      countEls.forEach(function (el) { el.remove(); });
    }
  }

  // Change a line's quantity via Shopify's Ajax Cart API, then refresh
  // this item's total and the cart-wide subtotal from the response.
  function changeLine(line, quantity, itemEl) {
    itemEl.classList.add('is-updating');

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateHeaderCartCount(cart.item_count);

        if (cart.item_count === 0) {
          // Simplest reliable way to show the empty-cart state without
          // duplicating that markup in JS.
          window.location.reload();
          return;
        }

        if (quantity === 0) {
          itemEl.remove();
          // Re-index remaining items' `data-line` attributes since Shopify's
          // line numbers are positional (1-based) and shift after a removal.
          var remaining = container.querySelectorAll('[data-cart-item]');
          remaining.forEach(function (el, index) {
            el.setAttribute('data-line', index + 1);
          });
        } else {
          var updatedLine = cart.items[line - 1];
          if (updatedLine) {
            var totalEl = itemEl.querySelector('[data-item-total]');
            if (totalEl) totalEl.textContent = formatMoney(updatedLine.original_line_price);
          }
          itemEl.classList.remove('is-updating');
        }

        var subtotalEl = document.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      })
      .catch(function () {
        itemEl.classList.remove('is-updating');
      });
  }

  container.addEventListener('click', function (event) {
    var decreaseBtn = event.target.closest('[data-qty-decrease]');
    var increaseBtn = event.target.closest('[data-qty-increase]');
    var removeBtn = event.target.closest('[data-remove-item]');

    if (decreaseBtn || increaseBtn) {
      var itemEl = (decreaseBtn || increaseBtn).closest('[data-cart-item]');
      var input = itemEl.querySelector('[data-qty-input]');
      var line = parseInt(itemEl.getAttribute('data-line'), 10);
      var current = parseInt(input.value, 10) || 1;
      var next = decreaseBtn ? Math.max(0, current - 1) : current + 1;

      input.value = next;
      changeLine(line, next, itemEl);
    }

    if (removeBtn) {
      var removeItemEl = removeBtn.closest('[data-cart-item]');
      var removeLine = parseInt(removeItemEl.getAttribute('data-line'), 10);
      changeLine(removeLine, 0, removeItemEl);
    }
  });

  container.addEventListener('change', function (event) {
    if (event.target.matches('[data-qty-input]')) {
      var itemEl = event.target.closest('[data-cart-item]');
      var line = parseInt(itemEl.getAttribute('data-line'), 10);
      var quantity = Math.max(0, parseInt(event.target.value, 10) || 0);
      changeLine(line, quantity, itemEl);
    }
  });

  // Order note
  var noteToggle = document.querySelector('[data-note-toggle]');
  var noteWrap = document.querySelector('[data-note-wrap]');
  var noteSave = document.querySelector('[data-note-save]');
  var noteInput = document.querySelector('[data-note-input]');

  if (noteToggle && noteWrap) {
    noteToggle.addEventListener('click', function () {
      noteWrap.hidden = !noteWrap.hidden;
    });
  }

  if (noteSave && noteInput) {
    noteSave.addEventListener('click', function () {
      var originalText = noteSave.textContent;
      noteSave.textContent = 'Saving...';

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: noteInput.value }),
      })
        .then(function () {
          noteSave.textContent = 'Saved';
          setTimeout(function () {
            noteSave.textContent = originalText;
          }, 1500);
        })
        .catch(function () {
          noteSave.textContent = originalText;
        });
    });
  }

  // Discount code — Shopify only validates/applies codes at checkout, so
  // this redirects to checkout with the code pre-applied via Shopify's
  // native discount deep-link.
  var discountInput = document.querySelector('[data-discount-input]');
  var discountApply = document.querySelector('[data-discount-apply]');

  if (discountApply && discountInput) {
    discountApply.addEventListener('click', function () {
      var code = discountInput.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
    });

    discountInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        discountApply.click();
      }
    });
  }
});